import React from 'react'

import api from '../services/api'
import locale from '../services/locale'

import '../stylesheets/pages/Feedback.scss'

export default class Feedback extends React.Component {
    state = {
        loading: false,
        feedback: '',
    }
    handleTerminate = async () => {
        const confirm = window.confirm(locale.translate('feedback_warning'))
        if (!confirm) return
        this.setState({ loading: true })
        await api.terminate(this.state.feedback)
        this.props.history.goBack()
    }
    render() {
        return (
            <div className="Feedback">
                <div className="Feedback_window">
                    <textarea
                        value={this.state.feedback}
                        onChange={(e) => this.setState({ feedback: e.target.value })}
                        placeholder={locale.translate('feedback_placeholder')}></textarea>
                    <button disabled={this.state.loading} onClick={this.handleTerminate}>
                        {locale.translate(`feedback_terminate`)}
                    </button>
                </div>
            </div>
        )
    }
}
